import request from '@/helpers/request'

export default {
  async index(data) {
    return await request.get('log', data)
  },
  async getToday() {
    return await request.get('log_today')
  },
  async show(id) {
    return await request.get('log/' + id)
  },
  async store(data) {
    return await request.post('log/store', data)
  },
  async update(data, id) {
    return await request.put('log/' + id, data)
  },
  async getUser() {
    return await request.get('log_user')
  },
  async updateLog(data) {
    return await request.put('users/update_log', data)
  }
}
